export const REQUEST_KINDS = {
  operational: {
    path: "/solicitacoes",
    title: "Solicitações operacionais",
  },
  administrative: {
    path: "/solicitacoes-administrativas",
    title: "Solicitações administrativas",
  },
};
